import axios from "axios";

export const getPrefilteredLink = (careersClientId) => {
  return axios
    .get(
      import.meta.env.VITE_ACTIVATE_BACKEND_API +
        "/api/prefilteredlink/" +
        encodeURIComponent(careersClientId)
    )
    .then((res) => res.data);
};
